import React, { useState } from "react";
import {
  IconButton,
  Card,
  CardHeader,
  LinearProgress
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ProfilesService from '../../../../../services/ProfilesService';
import actionsTopButtonStyles from '../../../../../screens/components/App/customMaterialStyles';
import { useDispatch, useSelector } from "react-redux";
import { showConfirmDialog } from "../../../../../redux/actions/uiConfirmDialog";
import ModalAddNewUser from "../modals/modalNewUser";
import { capitalize } from '../../../../../utils/string';


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: "0.07em",
    borderRadius: "0",    
    "&:first-child": {
      borderRadius: "5px 5px 0 0"
    },    
    
    "& .MuiCardHeader-root": {
      padding: "13px 25px"
    },
    "& .MuiCardHeader-title": {
      fontSize: "1.2rem",
      fontWeight: "500",
      letterSpacing: "0.7px"
    },
    "& .MuiCardHeader-subheader": {
      fontSize: "0.8rem",
      letterSpacing: "0.7px"
    }
  },
  collapse: {
    borderTop: "1px solid"
  },
  lastChild: {
    borderRadius: "50px 50px 0 0",
    color: "blue"
  }  
}));

function UserItem(props) {
  const { loading = false } = props;  
  const dispatch = useDispatch();
  const { user } = useSelector( state => state );
  
  const { id, first_name, last_name, profile_type, phone, is_active, email } = props.data || {};

  const classes = useStyles();
  const actionsTopButtonStylesClasses = actionsTopButtonStyles();

  const [isEditableForm, setIsEditableForm] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [openModalAddNewUser, setOpenModalAddNewUser] = useState(false);

  const handleClickOpenDialogRemove = () => {
    setIsLoadingSubmit(true);
    dispatch(
      showConfirmDialog(
        "Remove this User ?", 
        "You won't be able to revert this!", 
        handleOnDelete
      )
    );
  };

  const handleEditButton = () => {
    setIsEditableForm(true);
    setOpenModalAddNewUser(true);    
  }

  const handleOnDelete = async () => {        
    try{
      const userId = id;
      if(props.onDelete){
        await props.onDelete(userId, props.profile);           
      }else{
        await ProfilesService.deleteUser(userId, props.profile);         
      }      
      // handleCloseDialogRemove();
      props.removeItem(userId);
      setIsLoadingSubmit(false);
    }catch (error) {
      setIsLoadingSubmit(false);
    }  
  }

  const handleClickCloseModalAddNewUser = () => {
    setOpenModalAddNewUser(false);
    setIsEditableForm(false);
  };

  const getUserInformation = () => {    
    const tagProfileType = profile_type ? `${capitalize(profile_type)} | ` : '';
    const tagEmail = email ? `Email: ${email} | ` : '';
    const tagPhone = phone ? `Phone: ${phone} | ` : '';
    const tagEnabled = `Enabled: ${is_active ? 'True' : 'False'}`;
    return `${tagProfileType}${tagEmail}${tagPhone}${tagEnabled}`;
  }

  const buttonsBar = (
    <React.Fragment >
      { user && user.data.profile === 'manager' ?
        <IconButton 
          aria-label="edit-course" 
          className={clsx(actionsTopButtonStylesClasses.actionsTopButtons, {
            [actionsTopButtonStylesClasses.actionsTopButtonsSelected]: isEditableForm
          }) } 
          onClick={handleEditButton}>
          <EditOutlinedIcon />
        </IconButton>  
      : null}
      <IconButton aria-label="delete-course" className={actionsTopButtonStylesClasses.actionsTopButtons} onClick={handleClickOpenDialogRemove}>
        <DeleteForeverOutlinedIcon />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Card className={classes.root}>
      {/* Loading */}
      {isLoadingSubmit && <LinearProgress />}   
      
      {/* Course header */}
      <CardHeader
        action={
          loading ?
            <Skeleton
              variant="circle"
              width={50}
              height={50}
              style={{ marginBottom: 0 }}
            />
            :
            buttonsBar
        }        
        title={
          loading ? (
            <Skeleton
              variant="rect"
              width={180}
              height={20}
              style={{ marginBottom: 6 }}
            />
          ) : (
            `${first_name} ${last_name}`
          )
        }
        subheader={
          loading ? (
            <Skeleton variant="rect" width={210} height={10} />            
          ) : (
            getUserInformation()
          )
        }
      />        

      {/* Modal Dialog for Remove Data */}
      <ModalAddNewUser
        open={openModalAddNewUser}
        onClose={handleClickCloseModalAddNewUser}
        updateItemsList={props.updateItemsList}
        data={props.data}
        isEditModal={true}
        profile={props.profile}
      />
    </Card>
  );
}

export default UserItem;
